export const DEAL_FILTER_GROUPS = [
  {
    id: 'deal',
    label: 'Deal',
    filters: [
      {
        id: 'category',
        label: 'Category',
        type: 'checkbox',
        options: [
          { value: 'sales', label: 'Sales' },
          { value: 'fundraising', label: 'Fundraising' },
        ],
      },
      { id: 'stage', label: 'Stage', type: 'checkbox', options: [] },
      { id: 'status', label: 'Status', type: 'checkbox', options: [] },
      { id: 'owner', label: 'Owner', type: 'search', options: [] },
      { id: 'tags', label: 'Tags', type: 'search', options: [] },
      { id: 'source', label: 'Source', type: 'search', options: [] },
    ],
  },
  {
    id: 'fundraising',
    label: 'Fundraising',
    filters: [
      { id: 'giving_campaign', label: 'Giving campaign', type: 'search', options: [] },
    ],
  },
];

export const DEAL_FILTER_RANSACK_KEYS = {
  category: 'deal_type_in',
  stage: 'stage_in',
  status: 'status_in',
  owner: 'owner_team_membership_id_in',
  tags: 'tags_id_in',
  giving_campaign: 'giving_campaign_id_in',
  source: 'signup_form_submission_signup_form_id_in',
};
